import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

interface ReportButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isHomePage?: boolean;
}

export function ReportButton({ onClick, isHomePage = false }: ReportButtonProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      className={`
        flex items-center gap-1 text-xs
        ${isHomePage 
          ? 'border-orange-200 text-orange-600 hover:bg-orange-50 hover:border-orange-300' 
          : 'border-gray-200 text-gray-600 hover:bg-gray-50 hover:border-gray-300'
        }
      `}
      title="Segnala problemi con questo compro oro"
    >
      <AlertTriangle className="w-3 h-3" />
      <span className="hidden sm:inline">Segnala</span>
    </Button>
  );
}
